import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import { KeyRound, Loader2, CheckCircle2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { API } from "@/lib/config";
import { formatApiErrorDetail } from "@/lib/errors";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const [p1, setP1] = useState("");
  const [p2, setP2] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (p1.length < 8) return setErr("La password deve avere almeno 8 caratteri");
    if (p1 !== p2) return setErr("Le due password non coincidono");
    setLoading(true); setErr("");
    try {
      await axios.post(`${API}/auth/reset-password`, { token: params.get("token") || "", password: p1 });
      setDone(true);
    } catch (e2) { setErr(formatApiErrorDetail(e2.response?.data?.detail)); } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-slate-50 water-bg px-4 py-8" data-testid="reset-password-page">
      <form onSubmit={submit} className="w-full max-w-sm rounded-2xl bg-white border border-slate-200 shadow-sm p-6 sm:p-8 space-y-4" data-testid="reset-password-form">
        <span className="w-12 h-12 rounded-xl bg-sky-600 text-white grid place-items-center"><KeyRound className="w-6 h-6" /></span>
        <h1 className="text-2xl font-extrabold tracking-tight">Nuova password</h1>
        {done ? (
          <div className="space-y-4" data-testid="reset-password-done">
            <p className="flex gap-2 text-sm text-emerald-700"><CheckCircle2 className="w-5 h-5 shrink-0" /> Password aggiornata. Ora puoi accedere con la nuova password.</p>
            <Link to="/gestione" className="block text-center w-full h-12 leading-[3rem] rounded-full bg-sky-600 text-white font-bold" data-testid="reset-go-login">Vai all'accesso</Link>
          </div>
        ) : (
          <>
            <Input type="password" autoComplete="new-password" value={p1} onChange={(e) => setP1(e.target.value)} placeholder="Nuova password (min. 8 caratteri)" className="h-12" data-testid="reset-password-input" />
            <Input type="password" autoComplete="new-password" value={p2} onChange={(e) => setP2(e.target.value)} placeholder="Ripeti la password" className="h-12" data-testid="reset-password-confirm-input" />
            {err && <p className="text-sm font-semibold text-red-600" data-testid="reset-password-error">{err}</p>}
            <button disabled={loading} className="w-full h-12 rounded-full bg-sky-600 text-white font-bold hover:bg-sky-700 disabled:opacity-60 inline-flex items-center justify-center gap-2" data-testid="reset-password-submit">
              {loading && <Loader2 className="w-4 h-4 animate-spin" />} Salva password
            </button>
          </>
        )}
      </form>
    </div>
  );
}
